jQuery(document).ready(function ($) {
    $('.profile-content .login').click(function () {
        let login_register_modal = $('#login-register-modal')
        let body = $('body');
        login_register_modal.find('.errors').html('');
        login_register_modal.removeClass('show-register d-none show-forgot-password');
        body.addClass('modal-active');
        $('#toggleMenu').trigger('click');
    });

    $(document).on('click', '.show-login-modal', function () {
        let login_register_modal = $('#login-register-modal')
        let body = $('body');
        login_register_modal.find('.errors').html('');
        login_register_modal.removeClass('show-register d-none show-forgot-password');
        body.addClass('modal-active ');
    });

    $(document).on('click', '.btn-like-dislike', function (e) {
        let login_register_modal = $('#login-register-modal')
        let body = $('body');
        login_register_modal.find('.errors').html('');
        login_register_modal.removeClass('show-register d-none');
        body.addClass('modal-active disable-scroll');
    });

    $('.sign-up').click(function () {
        let login_register_modal = $('#login-register-modal')
        let body = $('body');
        login_register_modal.find('.errors').html('');
        login_register_modal.addClass('show-register');
        login_register_modal.removeClass('d-none show-forgot-password');
        body.addClass('modal-active ');
        $('#toggleMenu').trigger('click');
    });

    $('.show-sign-up-modal').click(function () {
        let login_register_modal = $('#login-register-modal')
        let body = $('body');
        login_register_modal.find('.errors').html('');
        login_register_modal.addClass('show-register');
        login_register_modal.removeClass('d-none');
        body.addClass('modal-active ');
    });

    $('.close-login-modal').click(function () {
        let login_register_modal = $('#login-register-modal')
        let body = $('body');
        login_register_modal.addClass('d-none');
        login_register_modal.removeClass('show-register');
        login_register_modal.find('.errors').html('');
        body.removeClass('modal-active disable-scroll');
    });

    $(document).mouseup(function (e) {
        let container = $("#login-register-modal");
        let form = container.find('form');
        let body = $('body');
        if (container.length && !container.hasClass('d-none')) {
            if (!form.is(e.target) && form.has(e.target).length === 0) {
                container.addClass('d-none');
                container.find('.errors').html('');
                body.removeClass('modal-active disable-scroll');
            }
        }
    });

    $('#open-login-modal').click(function () {
        let modal = $('#login-register-modal');
        modal.removeClass('show-register');
        modal.find('.errors').html('');
    });

    $('#open-register-modal').click(function () {
        let modal = $('#login-register-modal');
        modal.addClass('show-register');
        modal.find('.errors').html('');
    });

    $("#open-forgot-password-modal").on("click", function () {
        let modal = $('#login-register-modal');
        modal.addClass('show-forgot-password');
        modal.find('.errors').html('');
    })

    $("#back-to-login-modal").on("click", function () {
        let modal = $('#login-register-modal');
        modal.removeClass("show-forgot-password")
        modal.find('.errors').html('');
    })

    $(".modal-open").on("click", function () {
        $('#login-register-modal').addClass('show-register');
        $('#login-register-modal').removeClass('d-none');
        $('#login-register-modal').removeClass('show-forgot-password');
        $('body').addClass('modal-active disable-scroll');
    });

});